import { render, staticRenderFns } from "./CrmCardType.vue?vue&type=template&id=0fae90f7&"
import script from "./CrmCardType.vue?vue&type=script&lang=js&"
export * from "./CrmCardType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports